/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalUserEmployerSearchResponse } from './ExternalUserEmployerSearchResponse';
import {
    ExternalUserEmployerSearchResponseFromJSON,
    ExternalUserEmployerSearchResponseFromJSONTyped,
    ExternalUserEmployerSearchResponseToJSON,
    ExternalUserEmployerSearchResponseToJSONTyped,
} from './ExternalUserEmployerSearchResponse';
import type { PageModel } from './PageModel';
import {
    PageModelFromJSON,
    PageModelFromJSONTyped,
    PageModelToJSON,
    PageModelToJSONTyped,
} from './PageModel';

/**
 * 
 * @export
 * @interface ExternalUserEmployerSearchResponsePagedResult
 */
export interface ExternalUserEmployerSearchResponsePagedResult {
    /**
     * 
     * @type {PageModel}
     * @memberof ExternalUserEmployerSearchResponsePagedResult
     */
    pageInfo?: PageModel;
    /**
     * 
     * @type {Array<ExternalUserEmployerSearchResponse>}
     * @memberof ExternalUserEmployerSearchResponsePagedResult
     */
    data: Array<ExternalUserEmployerSearchResponse> | null;
}

/**
 * Check if a given object implements the ExternalUserEmployerSearchResponsePagedResult interface.
 */
export function instanceOfExternalUserEmployerSearchResponsePagedResult(value: object): value is ExternalUserEmployerSearchResponsePagedResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ExternalUserEmployerSearchResponsePagedResultFromJSON(json: any): ExternalUserEmployerSearchResponsePagedResult {
    return ExternalUserEmployerSearchResponsePagedResultFromJSONTyped(json, false);
}

export function ExternalUserEmployerSearchResponsePagedResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalUserEmployerSearchResponsePagedResult {
    if (json == null) {
        return json;
    }
    return {
        
        'pageInfo': json['pageInfo'] == null ? undefined : PageModelFromJSON(json['pageInfo']),
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(ExternalUserEmployerSearchResponseFromJSON)),
    };
}

export function ExternalUserEmployerSearchResponsePagedResultToJSON(json: any): ExternalUserEmployerSearchResponsePagedResult {
    return ExternalUserEmployerSearchResponsePagedResultToJSONTyped(json, false);
}

export function ExternalUserEmployerSearchResponsePagedResultToJSONTyped(value?: ExternalUserEmployerSearchResponsePagedResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageInfo': PageModelToJSON(value['pageInfo']),
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(ExternalUserEmployerSearchResponseToJSON)),
    };
}

